import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "summary", "badges"]

  connect() {
    this.boundOutsideClick = this.outsideClick.bind(this)
    document.addEventListener("click", this.boundOutsideClick)
    this.updateDisplay()
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    this.dropdownTarget.open = !this.dropdownTarget.open
  }

  close() {
    this.dropdownTarget.open = false
  }

  checkboxChanged() {
    this.updateDisplay()
  }

  outsideClick(event) {
    if (!this.dropdownTarget.open) return
    if (this.element.contains(event.target)) return
    this.dropdownTarget.open = false
  }

  updateDisplay() {
    const checked = this.element.querySelectorAll("[data-email-recipients-checkbox]:checked")
    const labels = Array.from(checked).map((cb) => cb.dataset.emailRecipientsLabel || cb.value)

    if (this.hasSummaryTarget) {
      if (labels.length === 0) {
        this.summaryTarget.textContent = "Select recipients..."
        this.summaryTarget.classList.add("text-base-content/60")
      } else {
        const preview = labels.slice(0, 3).join(", ")
        const suffix = labels.length > 3 ? ", ..." : ""
        this.summaryTarget.textContent = `${preview}${suffix}`
        this.summaryTarget.classList.remove("text-base-content/60")
      }
    }

    if (this.hasBadgesTarget) {
      if (labels.length === 0) {
        this.badgesTarget.innerHTML = ""
        this.badgesTarget.classList.add("hidden")
      } else {
        this.badgesTarget.classList.remove("hidden")
        this.badgesTarget.innerHTML = labels
          .map(
            (label) =>
              `<span class="badge badge-primary badge-soft gap-1">
                <span class="icon-[lucide--send] size-3"></span>
                ${this.escapeHtml(label)}
              </span>`
          )
          .join("")
      }
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
